import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import cs from 'vuetify/src/locale/cs';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#1144aa',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        colorEnter: '#98E598',
        colorExit: '#FF6262',
        colorComponentsBackground: '#F5F5F5',
        colorRowSelected: '#EBDECC',
        colorRowDifferentWorkplace: '#F2F2F2',
        colorRowWaitingForSignature: '#C2C2C2',
        colorRowRejectedSignature: '#D98484',
        colorHeadlineStandard: '#AB8571',
        colorHeadlineWarning: '#FF7150',
        colorHeadlineDelete: '#FF8787',
        colorSearchSettings: '#F8F8F8', // Hladanie v nastaveniach
        colorNew: '#B5E7FF',
        colorSave: '#80FFCF',
        colorEdit: '#FFE5B1',
        colorDelete: '#FF8787',
        colorClose: '#EFC19F',
        colorCancel: '#EFC19F',
        colorExport: '#FEECC8',
        colorExportFormat: '#FFE5B1',
        colorImport: '#FAF8DD',
        colorReport: '#BDE1FF',
        colorSearch: '#BDE1FF',
        colorStnBtn1: '#90CAF9',
        colorFilterTrue: '#EACBA7',
        colorFilterFalse: '#98E598',
        colorCheck: '#2A38AA',
      },
    },
  },
  icons: {
    // https://vuetifyjs.com/en/features/icon-fonts/#material-design-icons---js-svg
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  lang: {
    locales: { cs },
    current: 'cs',
  },
});
